import React, { Component } from "react";
import SideBar from "components/common/SideBar";
import NavBar from "components/common/NavBar";
import Footer from "components/common/Footer";
import { Router } from "@reach/router";
import AdminLanding from "components/AdminComponents/AdminLanding";
import Tracker from "components/AdminComponents/Tracker";
import Match from "components/AdminComponents/Match";
import InvestorStartupsArrange from "components/AdminComponents/InvestorStartupsArrange";
import InvestorsPage from "components/AdminComponents/InvestorsPage";
import Notifications from "components/common/Notifications";
import Mails from "components/AdminComponents/Mails";
import { adminRoutes } from "Routes";
// import SecondaryStake from "components/common/SecondaryStake";
import Contracts from "components/common/Contracts";
import { connect } from "react-redux";
// import RFQData from "components/AdminComponents/RFQData";
import Reporting from "components/AdminComponents/Reporting";
import TaskRunner from "components/AdminComponents/TaskRunner";
import AdminSecondaryStake from "components/AdminComponents/AdminSecondaryStake";
function mapStateToProps(state) {
  return {};
}
class AdminDashboard extends Component {
  componentDidMount() {
    // Api.getUserNotifications().then((response) => {
    //   this.props.dispatch({
    //     type: "AddNotification",
    //     payload: response.data,
    //   });
    // });
  }

  render() {
    return (
      <div className="App">
        <div className="wrapper">
          <SideBar links={adminRoutes} />
          <div className="main-panel">
            <NavBar authenticated={true} />
            <div className="content">
              <div className="container-fluid">
                <Router>
                  <AdminLanding path="/" />
                  <Tracker path="startup/:id" />
                  <TaskRunner path="task-runner" />
                  <Match path="match/:id" />
                  <InvestorStartupsArrange path="arrange/:id" />
                  <InvestorsPage path="investors/*" />
                  <Notifications path="notifications" />
                  <Mails path="mailing" />
                  <AdminSecondaryStake path="secondary-stake" />
                  <Contracts path="contracts" moderator={true} />
                  <Reporting path="reports" />
                </Router>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(AdminDashboard);
